// Phone layout (user 2026-10-12): one column instead of two — Messages / Notifications replace
// the page content and their buttons are an envelope and a bell; the X/Y/GO search hides behind a
// loupe that takes the whole top bar when opened, only the eye stays; a side-menu tap gives the page
// the full width (the left column disappears while a page or overlay is open). Decided by the user
// agent or a narrow window; never in XR. The frame publishes it as `game.phoneLayout` for the raw
// view modules (ui/views/index.js pageSize), which cannot import client code.
export const PHONE_MAX_WIDTH = 700;

export function isPhoneLayout() {
	if (globalThis.game?.renderer?.xr?.isPresenting) return false;
	const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
	const headset = /Pico|Quest|OculusBrowser/i.test(ua);
	if (headset) return false;
	const phoneUA = /Android|Mobile|iPhone|iPad|iPod/i.test(ua);
	return phoneUA || (typeof window !== 'undefined' && window.innerWidth < PHONE_MAX_WIDTH);
}

// Material Icons codepoints (PUA) for the phone bar
export const ICON_SEARCH = '';
export const ICON_MAIL = '';
export const ICON_BELL = '';
